module.exports = __webpack_public_path__ + "media/images/mobile-only/mobileonly-bubble-41b177147c6d7c1b46963963d6959e1f.png";